import { CancelToken } from "axios";
import {
  SendPackDeliveryPromiseDependantData,
  SendPackDeliveryPromise,
} from "@/types";
import { DeliveryApi } from "@/api/delivery.api";

export class SendPackDeliveryApi extends DeliveryApi {

  // Suggestions come from the Estonian address register, in the format SendPack expects.
  getAddresses(
    query: string,
    city: string,
    cancelToken?: CancelToken
  ): Promise<string[]> {
    return this.axios
      .get<{ suggestions: string[] }>(`/api/address/sendpack/autocomplete`, {
        params: { input: query, city },
        cancelToken,
      })
      .then((r) => r.data.suggestions);
  }

  calculateDelivery(
    saleId: number,
    data: SendPackDeliveryPromiseDependantData,
    cancelToken?: CancelToken
  ): Promise<SendPackDeliveryPromise> {
    return this.axios
      .post<{ promise: SendPackDeliveryPromise }>(
        "/delivery/sendpack/promise",
        { saleId, ...data },
        { cancelToken }
      )
      .then((r) => r.data.promise);
  }

  validateAddress(text: string, _restrictLocation: boolean, _city: string, saleId?: number): Promise<string | null> {
    return this.axios
      .post<{ valid: boolean }>("/api/address/sendpack/validate", { address: text, sale_id: saleId })
      .then((r) => (r.data.valid ? text : null));
  }
}
